import React from 'react';
import { Redirect } from 'react-router-dom';
import { Button, Avatar } from 'antd';
import DashBoard from '../dashboard/Dashboard';
import Methods from '../../Methods/index';


class ReportDetails extends React.PureComponent {
  onChange = (checked) => {
    console.log(`switch to ${checked}`);
  };

  viewProfile = (data) => {
    const { history } = this.props;
    history.push({
      pathname: '/profile',
      state: { detail: data.reportedBy },
    });
  }

  render() {
    const { location } = this.props;
    const data = Methods.routeDetail(location);
    if (!data) {
      // Opened without the reports list (typed URL, bookmark, new tab).
      return <Redirect to="/Reports" />;
    }
    const hasReporter = Methods.isPersonPresent(data.reportedBy);

    return (
      <DashBoard selectKey="reports" {...this.props}>
        <div className="shadowBox">
          <div className="reportTitle">
            <h1 className="page-title">{data.reason}</h1>
          </div>
          <div className="spotParkingDescription user-row">
            <p>
              {data.description}
            </p>
          </div>

          <div className="spotOwnerWrap user-row reporterInfo">
            <h2>Reporter Information</h2>
            <div className="spotOwner">
              {!hasReporter || data.reportedBy.profileImage === ''
                ? <Avatar size={80} icon="user" />
                : <img className="ownerProfileImg" src={Methods.download(data.reportedBy.profileImage)} alt="" />}

              <div>
                <h3>{Methods.fullName(data.reportedBy)}</h3>
                <p>{hasReporter && data.reportedBy.email}</p>
              </div>
              <Button className="profileBtn" disabled={!hasReporter} onClick={() => this.viewProfile(data)}>View Profile</Button>
            </div>
          </div>
        </div>
      </DashBoard>
    );
  }
}

export default ReportDetails;
